import { render, staticRenderFns } from "./BankingLoginInvite.vue?vue&type=template&id=093536a8&"
import script from "./BankingLoginInvite.vue?vue&type=script&lang=js&"
export * from "./BankingLoginInvite.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QIcon,QTooltip,QSeparator} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QIcon,QTooltip,QSeparator})
